import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    PopoverArrow,
    HStack,
    Text,
    Box,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {InfoIcon} from '../icons'
import {BRAND_KEY} from '../../brand'

const InfoPopover = ({
    trigger,
    variant = 'none',
    openTooltipOn,
    title,
    description,
    showInfoIcon = true,
}) => {
    const intl = useIntl()
    const style = useMultiStyleConfig('InfoPopover', {variant})
    const infoIconRef = React.useRef(null)

    useEffect(() => {
        const popups = document.querySelectorAll('.chakra-popover__popper')
        for (let i = 0; i < popups.length; i++) {
            popups[i].style.width = '256px'
        }
    }, [trigger])

    return (
        <Popover {...style.popover} trigger={openTooltipOn}>
            <PopoverTrigger>
                <Box
                    ref={infoIconRef}
                    tabIndex={0}
                    role="button"
                    aria-haspopup="dialog"
                    aria-label={intl.formatMessage({
                        id: 'info_popover.trigger.aria_label',
                        defaultMessage: 'More information',
                    })}
                >
                    {trigger}
                </Box>
            </PopoverTrigger>
            <PopoverContent
                {...style.container}
                data-testid="popover-content"
                role="dialog"
                aria-label={
                    title ||
                    intl.formatMessage({
                        id: 'global.info.popover.title.label',
                        defaultMessage: 'Information',
                    })
                }
            >
                <PopoverArrow {...style.arrow} />
                <PopoverBody {...style.body}>
                    <HStack {...style.hstack}>
                        {showInfoIcon && (
                            <InfoIcon
                                boxSize={[
                                    'iconsSize.small',
                                    'iconsSize.small',
                                    'iconsSize.small',
                                    'iconsSize.small',
                                ]}
                                fill="button.text.secondary-default"
                                color={
                                    BRAND_KEY === 'kenwood'
                                        ? 'button.text.secondary-default'
                                        : 'text.default'
                                }
                                cursor="default"
                                aria-hidden="true"
                                focusable="false"
                                role="presentation"
                            />
                        )}

                        <Box {...style.texts}>
                            {title !== null && title !== undefined && (
                                <Text {...style.title}>{title}</Text>
                            )}

                            <Text {...style.description}>
                                {description ||
                                    intl.formatMessage({
                                        id: 'global.info.popover.description',
                                        defaultMessage: 'Lorem ipsum dolor sit amet',
                                    })}
                            </Text>
                        </Box>
                    </HStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}

InfoPopover.propTypes = {
    variant: PropTypes.string,
    trigger: PropTypes.node.isRequired,
    placement: PropTypes.string,
    openTooltipOn: PropTypes.string,
    alignInfoIcon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    showInfoIcon: PropTypes.bool,
}

export default InfoPopover
